import React from 'react';
import type { BoostLowAverageRevenuePeriodsQuery } from 'generated/graphql';
import { useParams } from 'react-router-dom';
import { convertTo12HourFormat } from 'utils/dateTimeHelpers';
import { useModalContext } from 'common/Context/ModalContext';
import { AmplitudeEventCategories, AmplitudeEventProperties, logAmplitudeEvent } from 'utils/Amplitude';
import classNames from 'classnames';
import styles from './Boost.module.scss';

interface LowProps {
  weekday: string;
  to: string;
  from: string;
  posName: string;
  index: number;
}

const Low: React.FC<LowProps> = ({ weekday, to, from, posName, index }) => {
  const { venueId } = useParams<{ venueId: string }>();
  const { openModal } = useModalContext();

  const handlePricingOnClick = (): void => {
    if (venueId) {
      logAmplitudeEvent({
        name: 'view boost modal',
        category: AmplitudeEventCategories.BOOST,
        properties: {
          [AmplitudeEventProperties.SOURCE]: 'offers',
          [AmplitudeEventProperties.POS_NAME]: posName
        }
      });
      openModal({
        type: 'BOOST_LOW_CALL_TO_ACTION',
        isWideModal: true,
        venueId,
        posName
      });
    }
  };

  const formattedFrom = convertTo12HourFormat(from);
  const formattedTo = convertTo12HourFormat(to);

  return (
    <li data-testid={`boost-low-${index}}`}>
      <div className={styles.IconContainer}>
        <span className={styles.Icon}>⭐️</span>
      </div>
      <div className={styles.SuggestionContainer}>
        <p className={styles.Heading}>Order Quiet Time</p>
        <div className={styles.Suggestion}>
          <p>Try adding an offer based promotion</p>
          <p>
            {weekday} between {formattedFrom} - {formattedTo}
          </p>
        </div>
        <p className={styles.Estimated}>Promotions can increase order volume by 10%</p>
      </div>
      <div className={styles.ViewSurging}>
        <button type="button" onClick={handlePricingOnClick}>
          Boost orders
        </button>
      </div>
    </li>
  );
};

type VenueRevenuePeriodAverageFragment = BoostLowAverageRevenuePeriodsQuery['boostLowAverageRevenuePeriods'][0];
interface Props {
  lowRanges: VenueRevenuePeriodAverageFragment[];
  posName: string;
}

const BoostLows: React.FC<Props> = ({ lowRanges, posName }) => {
  return (
    <div className={classNames(styles.BoostPeaksContainer, styles.BoostLowsContainer)}>
      <ul>
        {lowRanges.map((lowRange, index) => (
          <Low
            key={`${lowRange.dayOfWeek}-${lowRange.periodTo}-${lowRange.periodFrom}`}
            weekday={lowRange.dayOfWeek}
            to={lowRange.periodTo}
            from={lowRange.periodFrom}
            posName={posName}
            index={index}
          />
        ))}
      </ul>
    </div>
  );
};

export default BoostLows;
